import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { PcbTabRoute } from '@/areas/pcb/Pcb/PcbLayout/PcbTabRoute';
import { PcbSpecificationPage } from '@/areas/pcb/Pcb/PcbSpecificationPage/PcbSpecificationPage';
import { assembliesModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/assemblies/$assemblyId/pcb/specification')({
    staticData: {
        access: { permissions: ['view:assembly'], modulePermissions: assembliesModulePermissions },
        chrome: 'home',
    } satisfies PageStaticData,
    validateSearch: stringSearch({ rfqId: 'required' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <PcbTabRoute tab={PcbSpecificationPage} />;
}
